import { LoadingScreen } from "@/components/elements/Loading/Loading";
import { POST_LOGIN_REDIRECT_KEY, redirectToCenter } from "@/utils/center";
import { useEffect } from "react";

const Login = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const redirectUrl = params.get("redirectUrl");
    if (redirectUrl) {
      sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, redirectUrl);
    }

    redirectToCenter({ replace: true });
  }, []);

  return <LoadingScreen />;
};

export default Login;
